import { render, staticRenderFns } from "./AddBanner.vue?vue&type=template&id=cf1c1030&"
import script from "./AddBanner.vue?vue&type=script&lang=js&"
export * from "./AddBanner.vue?vue&type=script&lang=js&"
import style0 from "./AddBanner.vue?vue&type=style&index=0&id=cf1c1030&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports